// extracted by mini-css-extract-plugin
module.exports = {"separator":"_1vV8g","postExcerpt":"_11MuE","postTitle":"_1Je0R"};